import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { get, post, put, del } from "./api";
Vue.prototype.httpGet = get;
Vue.prototype.httpPost = post;
Vue.prototype.httpPut = put;
Vue.prototype.httpDel = del;

import EventBus from './global/eventBus'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/ele_common.scss'
import './assets/css/more.scss'
import './assets/css/appCom.scss'
import './assets/icon/iconfont.css'

import pageView from "./components/common/pageView"
Vue.component('pageView', pageView);

window.$ = require("jquery");

Vue.use(EventBus);
Vue.use(ElementUI);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
